// import React, { useState } from "react";
// import "../assets/css/Grt.css";

// const GRTManagement = () => {
//   const [formData, setFormData] = useState({
//     branch: "",
//     officer: "",
//     description: "",
//     startDate: "",
//     center: "",
//     group: "",
//   });

//   const [data, setData] = useState([
//     {
//       id: 1,
//       grtId:"GRT001",
//       cgtId: "CGT001",
//       center: "Center A",
//       group: "Group X",
//       description: "Initial CGT session",
//       startDate: "2025-10-01",
//       grt:"28/04/2008",
//       employee:"001",
//       entryDate:"05/08/2022",
//     },
//     {
//       id: 2,
//       grtId:"GRT001",
//       cgtId: "CGT002",
//       center: "Center B",
//       group: "Group Y",
//       description: "Follow-up CGT",
//       startDate: "2025-10-03",
//       grt:"21/04/2008",
//       employee:"002",
//       entryDate:"05/08/2023",
//     },
//   ]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleAdd = () => {
//     if (!formData.branch || !formData.officer || !formData.center || !formData.group) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     const newData = {
//       id: data.length + 1,
//       grtId: `GRT00${data.length + 1}`,
//       cgtId: `CGT00${data.length + 1}`,
//       center: formData.center,
//       group: formData.group,
//       description: formData.description,
//       startDate: formData.startDate,
//       grt:formData.grt,
//       employee:formData.employee,
//       entryDate:formData.entryDate,
//     };
//     setData([...data, newData]);
//     setFormData({
//       branch: "",
//       description: "",
//       startDate: "",
//       center: "",
//       group: "",
//     });
//   };

//   return (
//     <div className="GRTManagement-container">
//       {/* --- CGT Form Section --- */}
//       <div className="GRTManagement-form">
//         <div className="GRTform-row">
//           <div className="GRTform-group">
//             <label>Branch</label>
//             <select name="branch" value={formData.branch} onChange={handleChange}>
//               <option value="">Select Branch</option>
//               <option value="Branch A">Branch A</option>
//               <option value="Branch B">Branch B</option>
//             </select>
//           </div>
//           <div className="GRTform-group">
//             <label>Employee</label>
//             <select name="officer" value={formData.officer} onChange={handleChange}>
//               <option value="">Select Employee</option>
//               <option value="Ravi Kumar">Ravi Kumar</option>
//               <option value="Anita Sharma">Anita Sharma</option>
//             </select>
//           </div>
//         </div>

//         <div className="GRTform-row">
//           <div className="GRTform-group">
//             <label>Description</label>
//             <input
//               type="text"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Enter description"
//             />
//           </div>
//           <div className="GRTform-group">
//             <label>GRT Start Date</label>
//             <input
//               type="date"
//               name="startDate"
//               value={formData.startDate}
//               onChange={handleChange}
//             />
//           </div>
//         </div>

//         <div className="GRTform-row">
//           <div className="GRTform-group">
//             <label>Center</label>
//             <input
//               type="text"
//               name="center"
//               value={formData.center}
//               onChange={handleChange}
//               placeholder="Enter Center"
//             />
//           </div>
//           <div className="GRTform-group">
//             <label>Group</label>
//             <select name="group" value={formData.group} onChange={handleChange}>
//               <option value="">Select Group</option>
//               <option value="Group X">Group X</option>
//               <option value="Group Y">Group Y</option>
//             </select>
//           </div>
//           <div className="GRTform-group">
//             <label>CGT ID</label>
//             <input
//               type="text"
//               name="center"
//               value={formData.center}
//               onChange={handleChange}
//               placeholder="Enter Center"
//             />
//           </div>
//         </div>

//         <div className="GRTform-action">
//           <button onClick={handleAdd}>Add</button>
//         </div>
//       </div>

//       {/* --- CGT Table Section --- */}
//       <div className="GRTManagement-table-container">
//         <h3>GRT Details</h3>

//          <div className="GRT-showingpage">

//         <div className="GRTtable-header">
//           <span>Showing Page 1 of 3</span>
//           <select>
//             <option>10</option>
//             <option>25</option>
//             <option>50</option>
//           </select>
//           <span>Result Per Page</span>
//           {/* Search Bar Section */}
// <div className="GRTManagement-searchbar">
//   <input
//     type="text"
//     placeholder="🔍 Search by CGT ID,Employee..."
//   />
//   <button className="GRT-but">Search</button>
// </div>
//         </div>
        
         
//         </div>

//         <table className="GRTManagement-table">
//           <thead>
//             <tr>
//               <th>Sr. No.</th>
//               <th>GRT ID</th>
//               <th>CGT ID</th>
//               <th>Center Name</th>
//               <th>Group Name</th>
//               <th>Description</th>
//               <th>GRT Date</th>
//               <th>Employee</th>
//               <th>Entry Date</th>
//               <th>Action</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.map((item, index) => (
//               <tr key={item.id}>
//                 <td>{index + 1}</td>
//                 <td>{item.grtId}</td>
//                 <td>{item.cgtId}</td>
//                 <td>{item.center}</td>
//                 <td>{item.group}</td>
//                 <td>{item.description}</td>
//                 <td>{item.startDate}</td>
//                 <td>{item.employee}</td>
//                 <td>{item.entryDate}</td>
//                 <td>
//                   <button className="GRTedit-btn">Edit</button>
//                   <button className="GRTdelete-btn">Delete</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default GRTManagement;


// --------------------------------


import React, { useMemo, useState } from "react";
import "../assets/css/Grt.css";
import { Edit, Trash } from "lucide-react";
import { toast } from "react-toastify";

const GRTManagement = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  const [loading,setLoading]=useState(false)
  const ITEMS_PER_PAGE_OPTIONS = [1, 2, 4];
  const [formData, setFormData] = useState({
    branch: "",
    officer: "",
    description: "",
    startDate: "",
    center: "",
    group: "",
  });

  const [data, setData] = useState([
    {
      id: 1,
      grtId:"GRT001",
      cgtId: "CGT001",
      center: "Center A",
      group: "Group X",
      description: "Initial CGT session",
      startDate: "2025-10-01",
      grt:"28/04/2008",
      employee:"001",
      entryDate:"05/08/2022",
    },
    {
      id: 2,
      grtId:"GRT001",
      cgtId: "CGT002",
      center: "Center B",
      group: "Group Y",
      description: "Follow-up CGT",
      startDate: "2025-10-03",
      grt:"21/04/2008",
      employee:"002",
      entryDate:"05/08/2023",
    },
  ]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    if (!formData.branch || !formData.officer || !formData.center || !formData.group) {
      toast.warn("Please fill all required fields.");
      return;
    }

    const newData = {
      id: data.length + 1,
      grtId: `GRT00${data.length + 1}`,
      cgtId: `CGT00${data.length + 1}`,
      center: formData.center,
      group: formData.group,
      description: formData.description,
      startDate: formData.startDate,
      grt:formData.grt,
      employee:formData.employee,
      entryDate:formData.entryDate,
    };
    setData([...data, newData]);
    setFormData({
      branch: "",
      description: "",
      startDate: "",
      center: "",
      group: "",
    });
  };

  // Search + Pagination
  const filteredData = useMemo(() => {
    return data.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    );
  }, [data, searchQuery]);

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div className="group-grt-container">
      <h1 className="group-grt-heading">Group GRT</h1>

      {/* ================= FORM ================= */}
      <section className="group-grt-top">
        <form className="group-grt-form" onSubmit={handleAdd}>
          <div className="group-grt-form-section">
            <div className="group-grt-form-input-fields">
               <label>Branch</label>
             <select name="branch" value={formData.branch} onChange={handleChange}>
               <option value="">Select Branch</option>
               <option value="Branch A">Branch A</option>
               <option value="Branch B">Branch B</option>
             </select>
            </div>

            <div className="group-grt-form-input-fields">
               <label>Employee</label>
             <select name="officer" value={formData.officer} onChange={handleChange}>
               <option value="">Select Employee</option>
               <option value="Ravi Kumar">Ravi Kumar</option>
               <option value="Anita Sharma">Anita Sharma</option>
             </select>
            </div>

            <div className="group-grt-form-input-fields">
             <label>Description</label>
             <input
               type="text"
               name="description"
               value={formData.description}
               onChange={handleChange}
               placeholder="Enter description"
             />
            </div>

            <div className="group-grt-form-input-fields">
              <label>GRT Start Date</label>
             <input
               type="date"
               name="startDate"
               value={formData.startDate}
               onChange={handleChange}
             />
            </div>

            <div className="group-grt-form-input-fields">
              <label>Center</label>
             <input
               type="text"
               name="center"
               value={formData.center}
               onChange={handleChange}
               placeholder="Enter Center"
             />
            </div>

            <div className="group-grt-form-input-fields">
             <label>Group</label>
             <select name="group" value={formData.group} onChange={handleChange}>
               <option value="">Select Group</option>
               <option value="Group X">Group X</option>
               <option value="Group Y">Group Y</option>
             </select>
            </div>

            <div className="group-grt-form-input-fields">
             <label>CGT ID</label>
             <input
               type="text"
               name="center"
               value={formData.center}
               onChange={handleChange}
               placeholder="Enter Center"
             />
            </div>
          </div>
          <div className="group-grt-form-submit-btn">
             <button>Add</button>
          </div>
        </form>
      </section>

      {/* ================= REPORT SECTION ================= */}
      <div className="group-grt-report-container">
        <h1>GRT Details</h1>
        <div className="group-grt-report-filter-div">
          <input
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          <div className="group-grt-filter">
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="group-grt-report-table-container">
          <table className="group-grt-report-table">
            <thead>
              <tr>
                <th>Sr. No.</th>
               <th>GRT ID</th>
               <th>CGT ID</th>
               <th>Center Name</th>
               <th>Group Name</th>
               <th>Description</th>
               <th>GRT Date</th>
               <th>Employee</th>
               <th>Entry Date</th>
               <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.length > 0 ? (
                paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                 <td>{item.grtId}</td>
                 <td>{item.cgtId}</td>
                 <td>{item.center}</td>
                 <td>{item.group}</td>
                 <td>{item.description}</td>
                 <td>{item.startDate}</td>
                 <td>{item.employee}</td>
                 <td>{item.entryDate}</td>
                <td className="group-action-btns">
                      <Edit
                        className="edit-icon"
                      />
                      <Trash
                        className="delete-icon"
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  {loading ? (
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      Loading...
                    </td>
                  ) : (
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      No results found
                    </td>
                  )}
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {filteredData.length > itemsPerPage && (
          <div className="group-grt-pagination-div">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              ⬅ Prev
            </button>

            <span>
              {" "}
              Page {currentPage} of {totalPages}{" "}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next ➡
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GRTManagement;
